import React from 'react'
import { Button } from '../../components'
import { NotFound as icons } from '../../assets/images'
import './index.scss'
import { useTranslation } from 'react-i18next'

const  NotFound = function () {
    const { t } = useTranslation()
    return (
        <div className='not-found-page'>
            <div className='container'>
                <img src={icons.icon} alt='404' />
                <div className='content'>
                    <h2>{t('notFound.h1')}</h2>
                    <p>{t('notFound.p')}</p>
                    <Button type='link' to='/'>{t('notFound.button')}</Button>
                </div>
            </div>
        </div>
    )
}

export default NotFound